const getDragDropAreaClassName = (isDraggingOver: boolean, dragClassPrefix = "csa-drop-area"): string => {
  return isDraggingOver ? `${dragClassPrefix}-dropping` : `${dragClassPrefix}`;
};

export default getDragDropAreaClassName;
